/**
 * Per-category banner content (emoji + headline + subheadline).
 * Keys are category slugs (must match backend category slugs exactly).
 *
 * If a slug isn't here, the page falls back to the category name + a
 * generic subheadline.
 */
const CATEGORY_BANNER = {
  'electronics-computers': {
    emoji: '💻',
    label: 'Electronics & Computers',
    headline: 'Technology That Moves You Forward.',
    subheadline:
      'Discover devices, equipment and innovations that help you work, create, learn and play.',
  },
  insurance: {
    emoji: '🛡️',
    label: 'Insurance',
    headline: 'Protection Starts With Confidence.',
    subheadline:
      'Compare trusted insurance options and choose cover designed around your life and goals.',
  },
  vehicles: {
    emoji: '🚗',
    label: 'Vehicles',
    headline: 'Your Next Journey Starts Here.',
    subheadline:
      'Discover vehicles from trusted sellers and find the right match for your lifestyle, business or adventure.',
  },
  property: {
    emoji: '🏠',
    label: 'Property',
    headline: 'Find A Place To Call Home.',
    subheadline:
      'Explore properties for sale, rent and investment opportunities in the places that matter most.',
  },
  'business-industry': {
    emoji: '🏭',
    label: 'Business & Industry',
    headline: 'Where Business Meets Opportunity.',
    subheadline:
      'Connect with equipment, suppliers, services and investment opportunities that help businesses grow.',
  },
  'auto-parts-accessories': {
    emoji: '🔧',
    label: 'Auto Parts & Accessories',
    headline: 'Everything Your Vehicle Needs.',
    subheadline:
      'Find parts, accessories and upgrades from trusted sellers and specialists.',
  },
  'home-garden': {
    emoji: '🏡',
    label: 'Home & Garden',
    headline: 'Create A Space You Love.',
    subheadline:
      'Discover furniture, décor, tools and outdoor living solutions for every home.',
  },
  'fashion-beauty': {
    emoji: '👗',
    label: 'Fashion & Beauty',
    headline: 'Style That Speaks For You.',
    subheadline:
      'Discover fashion, beauty and personal care products designed for every lifestyle.',
  },
  'sports-fitness-hobbies': {
    emoji: '⚽',
    label: 'Sports, Fitness & Hobbies',
    headline: 'Fuel Your Passion.',
    subheadline:
      'Find equipment, experiences and communities that help you do more of what you love.',
  },
  jobs: {
    emoji: '💼',
    label: 'Jobs',
    headline: 'Find Work Worth Doing.',
    subheadline:
      'Connect talent with opportunity and discover careers that match your ambitions.',
  },
  'services-trades': {
    emoji: '🛠️',
    label: 'Services & Trades',
    headline: 'Find Experts You Can Trust.',
    subheadline:
      'Connect with skilled professionals ready to help with projects, repairs and specialist services.',
  },
  'food-agriculture': {
    emoji: '🌾',
    label: 'Food & Agriculture',
    headline: 'Growing Opportunities Together.',
    subheadline:
      'Connect producers, suppliers, buyers and communities across food and agriculture.',
  },
  'education-tuition': {
    emoji: '📚',
    label: 'Education & Tuition',
    headline: 'Learn Today. Grow Tomorrow.',
    subheadline:
      'Discover courses, tutors and educational opportunities that unlock potential.',
  },
  'baby-kids-items': {
    emoji: '👶',
    label: 'Baby & Kids Items',
    headline: 'Everything For Growing Families.',
    subheadline:
      'Discover trusted products, services and opportunities for babies, children and parents.',
  },
  'pets-animals': {
    emoji: '🐾',
    label: 'Pets & Animals',
    headline: 'Because Every Companion Matters.',
    subheadline:
      'Find pets, supplies, services and opportunities that support animal wellbeing.',
  },
  'musical-instruments': {
    emoji: '🎸',
    label: 'Musical Instruments',
    headline: 'Bring Music To Life.',
    subheadline:
      'Discover instruments, equipment and opportunities for musicians of every level.',
  },
  'events-functions': {
    emoji: '🎉',
    label: 'Events & Functions',
    headline: 'Make Every Occasion Memorable.',
    subheadline:
      'Find venues, entertainment, suppliers and services for events worth celebrating.',
  },
  'community-local-life': {
    emoji: '🤝',
    label: 'Community & Local Life',
    headline: 'Stronger Communities Start Here.',
    subheadline:
      'Discover local groups, services, activities and opportunities that bring people together.',
  },
  'books-media': {
    emoji: '📖',
    label: 'Books & Media',
    headline: 'Ideas Worth Discovering.',
    subheadline:
      'Explore books, media and knowledge that inform, entertain and inspire.',
  },
  other: {
    emoji: '📦',
    label: 'Other',
    headline: 'Discover Something Unexpected.',
    subheadline:
      'Explore unique products, services and opportunities beyond traditional categories.',
  },
};

/**
 * Look up banner content for a given category slug.
 * Returns null when no entry exists so the caller can fall back to a
 * generic header (e.g. for All Ads / Search results).
 */
export function getCategoryBanner(slug) {
  if (!slug || slug === 'all') return null;
  return CATEGORY_BANNER[slug] || null;
}

export default CATEGORY_BANNER;
